export default {
  setLocal: (name, val) => {
    window.localStorage.setItem(name, val)
  },
  getLocal: (name, val) => {
    window.localStorage.getItem(name)
  },
  removeLocal: name => {
    window.localStorage.removeItem(name)
  },

  setLocalByObj: (name, obj) => {
    window.localStorage.setItem(name, JSON.stringify(obj))
  },
  getLocalByObj: (name) => {
    return JSON.parse(window.localStorage.getItem(name))
  },

  setSession: (name, val) => {
    if (typeof val === 'object') {
      val = JSON.stringify(val)
    }
    window.sessionStorage.setItem(name, val)
  },
  getSession: (name) => {
    let value = window.sessionStorage.getItem(name)
    if (isJson(value)) {
      return JSON.parse(value)
    } else {
      return value
    }
  },
  removeSession: (name) => {
    window.sessionStorage.removeItem(name)
  },

  setSessionByObj: (name, obj) => {
    window.sessionStorage.setItem(name, JSON.stringify(obj))
  },
  getSessionByObj: (name) => {
    return JSON.parse(window.sessionStorage.getItem(name))
  }
}

const isJson = (str) => {
  if (typeof str === 'string') {
    try {
      JSON.parse(str)
      if (str.indexOf('{') > -1) {
        return true
      } else {
        return false
      }
    } catch (e) {
      console.log(e)
      return false
    }
  }
  return false
}



// WEBPACK FOOTER //
// ./src/utils/session.js